import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { apiDelete } from '@/lib/api';
import { pricebookKeys } from '@/lib/queryKeys';
import { useApiMutation } from '../useApiMutation';
import { usePricebookApi } from './usePricebookApi';

/**
 * NOT-105: Archive (soft-delete) a pricebook line item.
 *
 * Hard delete is intentionally not available because items can be referenced
 * by packages, estimates, and jobs — removing the row would break those
 * records. The server's DELETE endpoint flips status → ARCHIVED, sets
 * isDeleted=true, and stamps archivedAt/deletedAt. The row stays in the DB
 * and can be un-archived via {@link useRestoreItem}.
 */
export function useArchiveItem() {
  const queryClient = useQueryClient();
  const { client, ep } = usePricebookApi();

  return useApiMutation<void, string>({
    mutationFn: (id) => apiDelete<void>(client, ep.archive(id)),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: pricebookKeys.all() });
      toast.success('Item archived');
    },
  });
}
